/** Domain shelves are the stable catalogue; Added is an additional view. */
export function regimeShelves<T extends { id: string; enabled: boolean; domain: string | null }>(
  regimes: readonly T[],
) {
  const domains = new Map<string, T[]>();
  for (const regime of regimes) {
    const domain = regime.domain ?? "Other";
    const items = domains.get(domain) ?? [];
    items.push(regime);
    domains.set(domain, items);
  }
  return [
    {
      key: "added",
      title: "Added",
      items: regimes.filter((regime) => regime.enabled),
      added: true,
    },
    ...Array.from(domains, ([title, items]) => ({
      key: `domain:${title}`,
      title,
      items,
      added: false,
    })),
  ];
}

type SearchableRegime = {
  readonly name: string;
  readonly slug: string;
  readonly issuer: string | null;
  readonly jurisdiction: string | null;
  readonly domain: string | null;
  readonly version: string | null;
  readonly description: string | null;
};

/**
 * The Regimes search: every word must appear somewhere in the regime's name,
 * slug, issuer, jurisdiction, area, version or description, so "fca conduct"
 * finds the FCA's conduct rules wherever each word sits.
 */
export function regimeMatchesSearch(regime: SearchableRegime, search: string): boolean {
  const words = search.trim().toLowerCase().split(/\s+/u).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = [
    regime.name,
    regime.slug,
    regime.issuer,
    regime.jurisdiction,
    regime.domain,
    regime.version,
    regime.description,
  ]
    .filter((field): field is string => Boolean(field))
    .join("\n")
    .toLowerCase();
  return words.every((word) => haystack.includes(word));
}
